import axios from "axios";

import { useSWRMutate } from "./useSWR";

const assessmentService = axios.create({
  baseURL: window.wwBasePath.getAttribute("href"),
  timeout: 5000
});

export const logger = async (key, { arg: data = {} }) => {
  try {
    const response = await assessmentService.post(
      "/api/assessments/logger",
      data
    );

    return response;
  } catch (error) {
    console.error("Error logging", error);
  }
};

export const useLogger = () =>
  useSWRMutate("logger", logger, { throwOnError: false });
